import AutoStoriesIcon from "@mui/icons-material/AutoStories";

import List from "../VersionObjects/List";
import Edit from "../VersionObjects/Edit";
import Create from "../VersionObjects/Create";
import Show from "../VersionObjects/Show";

export const getPagesResource = ({ permission }) => {
  return {
    isMenu: true,
    icon: <AutoStoriesIcon />,
    name: "pages-cms",
    title: "Страници",
    create: <Create mode="page" />,
    list: <List mode="page" />,
    edit: <Edit mode="page" />,
    show: <Show mode="page" />,
    permission,
  };
};
